import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { CATEGORIES } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/site/PageHeader";
import { EventCard } from "@/components/site/EventCard";
import { Reveal } from "@/components/site/Motion";

export default function Events() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const category = params.get("category") || "";
  const query = params.get("q") || "";
  const { data, loading } = useFetch(`/events?q=${encodeURIComponent(query)}&category=${category}&limit=60`, []);
  const events = Array.isArray(data) ? data : [];

  useEffect(() => {
    setQ(query);
  }, [query]);

  const update = (next) => {
    const p = { q: query, category, ...next };
    Object.keys(p).forEach((k) => !p[k] && delete p[k]);
    setParams(p);
  };

  return (
    <main data-testid="events-page">
      <PageHeader eyebrow="Galerias de eventos" title={["Encontre o evento.", <span key="b" className="text-flash">Encontre você.</span>]} testid="events-header">
        <form onSubmit={(e) => { e.preventDefault(); update({ q }); }} className="mt-10 flex max-w-xl items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] p-1.5 pl-5 backdrop-blur-xl">
          <Search className="h-4 w-4 text-haze" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome do evento ou local" data-testid="events-search-input" className="w-full bg-transparent outline-none placeholder:text-haze/80" />
          <button className="rounded-full bg-flash px-5 py-2.5 text-sm font-semibold text-ink" data-testid="events-search-btn">Buscar</button>
        </form>
        <div className="mt-6 flex flex-wrap gap-2">
          {[{ id: "", label: "Todos" }, ...CATEGORIES].map((c) => (
            <button key={c.id || "all"} onClick={() => update({ category: c.id })} data-testid={`events-filter-${c.id || "all"}`}
              className={`rounded-full border px-4 py-2 text-sm transition-colors duration-300 ${category === c.id ? "border-flash bg-flash text-ink" : "border-white/15 hover:border-white/40"}`}>
              {c.label}
            </button>
          ))}
        </div>
      </PageHeader>
      <section className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        {loading ? (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{[0, 1, 2].map((i) => <div key={i} className="aspect-[4/3] animate-pulse rounded-[1.5rem] bg-ink-2" />)}</div>
        ) : events.length ? (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="events-grid">
            {events.map((ev, i) => <Reveal key={ev.id} delay={(i % 3) * 0.06}><EventCard ev={ev} /></Reveal>)}
          </div>
        ) : (
          <div className="rounded-[1.5rem] border border-dashed border-white/15 p-14 text-center" data-testid="events-empty">
            <p className="font-display text-2xl font-bold">Nenhum evento encontrado.</p>
            <p className="mt-2 text-haze">Tente outro nome ou categoria.</p>
          </div>
        )}
      </section>
    </main>
  );
}
